export const ENROLLMENT_RESET_VERIFY_EMAIL = 'ENROLLMENT_RESET_VERIFY_EMAIL';

export const enrollmentResetVerifyEmail = () => dispatch =>
  dispatch({
    type: ENROLLMENT_RESET_VERIFY_EMAIL,
  });
